/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../../extendIcon';

const GeofenceCircle = props => (
  <svg viewBox="0 0 128 128" width="1em" height="1em" {...props}>
    <circle fill="none" cx={63.333} cy={63.483} r={56.776} />
  </svg>
);
export default extendIcon(GeofenceCircle);
